import { createSlice } from "@reduxjs/toolkit";

export const messageLogSlice = createSlice({
  name: "messageLog",
  initialState: {
    messageLog: [],
    masking: [],
    fixedNumber: [],
    gatewayLog: [],
    gatewayBalance: 0,
  },
  reducers: {
    getMessageLogSlice: (state, action) => {
      state.messageLog = action.payload;
    },
    getMaskingMessageLogSlice: (state, action) => {
      state.masking = action.payload;
    },
    getPersonalMessageGatewayLogsSuccess: (state, action) => {
      state.gatewayLog = action.payload;
    },
    getPersonalMessageGatewayBalanceSuccess: (state, action) => {
      state.gatewayBalance = action.payload;
    },
  },
});

export const {
  getMessageLogSlice,
  getMaskingMessageLogSlice,
  getFixedNumberMessageLogSlice,
  getPersonalMessageGatewayLogsSuccess,
  getPersonalMessageGatewayBalanceSuccess,
} = messageLogSlice.actions;
export default messageLogSlice.reducer;
